<span class="ui-badge" [attr.data-tone]="tone()">{{ label() | uiLabelTranslate }}</span>
